import React from "react";
import { useLoadScript } from "@react-google-maps/api";
import { Box, CircularProgress, Typography } from "@mui/material";

// Define the libraries once to avoid recreation
const libraries: ("places" | "geometry" | "drawing" | "visualization")[] = [
  "places",
];

interface GoogleMapsProviderProps {
  children: React.ReactNode;
}

export const GoogleMapsProvider: React.FC<GoogleMapsProviderProps> = ({
  children,
}) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey:
      (window.__config?.REACT_APP_GOOGLE_MAPS_API_KEY as string) || "",
    libraries,
  });

  if (loadError) {
    console.error("Error loading Google Maps:", loadError);
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "200px",
          gap: 2,
        }}
      >
        <Typography color="error" variant="h6">
          Error loading Google Maps
        </Typography>
        <Typography color="text.secondary" variant="body2">
          Please refresh the page or contact support if the problem persists.
        </Typography>
      </Box>
    );
  }

  if (!isLoaded) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "200px",
          gap: 2,
        }}
      >
        {/* <CircularProgress />
        <Typography color="text.secondary" variant="body2">
          Loading Google Maps...
        </Typography> */}
      </Box>
    );
  }

  return <>{children}</>;
};

// Export libraries for use in other components
export { libraries };
